<template>
  <ul class="divide-y divide-gray-200">
    <template v-if="people.length">
      <li v-for="person in people" :key="person.id" class="px-6 py-4">
        <PersonAssociateItem :person="person" @associate="associatePerson" />
      </li>
    </template>
    <template v-else>
      <li class="px-6 py-4">
        <div class="flex items-center space-x-4">
          <div class="flex-1 min-w-0 text-center">
            No Person match with contact
            <span class="block mt-2 font-medium text-blue-600">
              {{ contact.firstName }} {{ contact.lastName }}
            </span>
          </div>
        </div>
      </li>
    </template>
  </ul>
</template>

<script>
import { contactPersonClient } from '@/api/clients';
import { CONTACTS } from '@/store/entities/schema_types';
import PersonAssociateItem from './PersonAssociateItem.vue';

export default {
  components: { PersonAssociateItem },
  props: {
    people: {
      type: Array,
      default: () => [],
    },
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async associatePerson(person) {
      try {
        this.loading = true;

        const response = await contactPersonClient.update(this.contact.id, {
          person_id: person.id,
        });

        await this.$store.dispatch('entities/persistEntities', {
          type: CONTACTS,
          data: response.data,
        });

        this.$emit('associated', person.id);
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
